import { sendPost } from '../http.js'
const api = {
	'grouplist': '/user/user/product/group/list',
    'addgroup': '/user/user/product/group',
	'groupsort': '/user/user/product/group/sort',
	'groupremove': '/user/user/product/group/remove',
	'sectionsort': '/user/user/sortshow',

}

export default {
	grouplist(params) {
		return sendPost(api.grouplist, params)
	},
    addgroup(params) {
		return sendPost(api.addgroup, params)
	},
    groupsort(params) {
		return sendPost(api.groupsort, params)
	},
	sectionsort(params) {
		return sendPost(api.sectionsort, params)
	},
    groupremove(params) {
		return sendPost(api.groupremove, params)
	}
}
